@if (formGroup) {
  <form [formGroup]="formGroup" class="main-container" (ngSubmit)="submit()">
    <div class="sidebar">
      <app-template-editor-side-bar [builder]="templateBuilder" />
    </div>
    <div class="main">
      <div class="header-container">
        <div class="left-container">{{ item.title || "Create new template" }}</div>
        <div class="right-container">
          @if (availableLanguages.length > 1) {
            <app-language-selection
              [(ngModel)]="selectedLanguage"
              [languages]="availableLanguages"
              [ngModelOptions]="{ standalone: true }"
              [searchBar]="false"
              size="25px" />
          }
        </div>
      </div>

      <div class="content">
        <app-template-editor-form [builder]="templateBuilder" />
      </div>

      <div class="actions-container">
        <sag-ui-button color="secondary" [disabled]="isSaving" (click)="close()">
          {{ "default.buttons.cancel" | translate }}
        </sag-ui-button>
        <sag-ui-button type="submit" color="primary" [disabled]="isSaving">
          {{ "default.buttons.save" | translate }}
        </sag-ui-button>
      </div>
    </div>
  </form>
} @else {
  <app-loading-indicator [backgroundColor]="'transparent'" />
}
